import React, { useEffect, useRef, useState } from "react";
import * as echarts from 'echarts';
import { Graph_Name, Graphs, NOT_AVAILABLE } from "../../utils/constants/insightsConstants";
import IMAGES from "../../assets/images/images";
import styles from './lineChart.module.css'

const defaultStyle = { width: "100%", height: "400px" };

const defaultColors = [
  '#2874A6','#23B561','#DEBC36','#EE6767','#AE69CB','#016EF4','#FFC46B','#148F77','#194B9A','#7D3C98',
  '#FECB00','#D2691E','#C08081','#007C92','#00CF30','#9C2AA0','#00B0CA','#5E4682','#FF9A3C','#3EA0E2'
];

const LineChart = ({ handleSelectedFilters,legend,xAxisData, series,rawSeriesDataForTooltip={}, style = defaultStyle, YAxisName,XAxisName='', grpahType, graphName }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [selectedKeys, setSelectedKeys] = useState(() =>
    legend.reduce((acc, name) => {
      acc[name] = true;
      return acc;
    }, {})
  );

  useEffect(() => {
    if (typeof handleSelectedFilters === 'function') {
      handleSelectedFilters(selectedKeys);
    }
  }, [selectedKeys]);
  

  const formatNumberWithUnits = (number) => {
    //const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let units=[];
        if(graphName==Graph_Name.Peak_In_Out){
            units = ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps'];
        }else{
            units = ['KB', 'MB', 'GB', 'TB'];
}

    let i = 0;
    while (number >= 1000 && i < units.length - 1) {
      number /= 1000;
      i++;
    }
    return number.toFixed(2) + ' ' + units[i]
  }

  const getYAxisOptions = (showLabel = true) => ({
    type: 'value',
    axisLine:{
       show:true,
        lineStyle:{
           color:"#666666"
           } 
          },
    name: grpahType !== Graphs.WEATHERMAPS && showLabel ? YAxisName : '',
    nameTextStyle: {
      align: "right",
      color: "#666666",
      fontFamily: "VodafoneLt-Regular",
      fontSize: 14,
    },
    axisLabel: {
      formatter: grpahType === Graphs.WEATHERMAPS
        ? (value) => formatNumberWithUnits(value)
        : undefined,
      textStyle:{
        color:"#666666",
        fontFamily:"VodafoneLt-Regular",
        fontSize:14,
      }
    }
  });

  const tooltipOptions = {
    trigger: 'axis',
    formatter: grpahType === Graphs.WEATHERMAPS
      ? function (params) {
        let tooltipText = params[0].name + '<br/><table style="width:100%">';
        params.forEach(item => {
          tooltipText+='<tr>'+
          '<td style="text-align:left;padding-right: 16px;">' +item.marker + item.seriesName + '</td>'+
          '<td style="text-align:right;font-weight: bold">' +formatNumberWithUnits(item.value) + '</td>'+
          '</tr>'
})
        tooltipText+='</table>'
        return tooltipText;
      }
      : undefined
  };


const toZeroData=(data)=> {
  return data.map(v => (v == null ? 0 : v));
}


  useEffect(() => {
    const myChart = echarts.init(chartRef.current);
    chartInstance.current = myChart;

    const colorMap = legend.reduce((acc, name, index) => {
      acc[name] = defaultColors[index % defaultColors.length];
      return acc;
    }, {});
    const allDeselected = Object.values(selectedKeys).every(value => !value);
    const options = {
      color: legend.map(name => colorMap[name]),
      tooltip: tooltipOptions,
      legend: { show: false },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xAxisData,
        name:XAxisName,
        nameTextStyle: {
          color: "#666666",
          fontFamily: "VodafoneLt-Regular",
          fontSize: 14,
        },
        axisLabel: {
//interval: Math.round(xAxisData?.length/40),
          rotate: 45,
          //hideOverlap: true,
                    textStyle:{
            color:"#666666",
            fontFamily:"VodafoneLt-Regular",
            fontSize:14
          }
        },
        axisLine:{
                    lineStyle:{
                        color:"#666666"
                     }
                 },
               
      },
      yAxis: getYAxisOptions(!allDeselected),
      dataZoom: [{ type: 'inside', start: 0, end: 100 }],
     series: series
      .filter(s => selectedKeys[s.name]) 
      .map((s, index) => ({
        ...s,
        //data: Array.isArray(s.data) ? toZeroData(s.data) : s.data,
        itemStyle: { color: colorMap[s.name] },
        lineStyle: { color: colorMap[s.name] },
        areaStyle: s.areaStyle ? { color: colorMap[s.name] } : undefined,
        z:1
      })),
      grid: { containLabel: true, left: 90, bottom: 10, right: XAxisName? 60:10, height: '350' },
    };

    myChart.setOption(options);
    window.addEventListener('resize', myChart.resize);
    return () => {
      myChart.dispose();
      window.removeEventListener('resize', myChart.resize);
    };
  }, [legend, xAxisData, series, YAxisName,XAxisName, grpahType, graphName,selectedKeys]);

  const toggleSeries = (name) => {
    const isSelected = selectedKeys[name];
    const updatedKeys = { ...selectedKeys, [name]: !isSelected };
    setSelectedKeys(updatedKeys);

    if (chartInstance.current) {
      chartInstance.current.dispatchAction({
        type: isSelected ? 'legendUnSelect' : 'legendSelect',
        name
      });

      const allDeselected = Object.values(updatedKeys).every(value => !value);
      if (grpahType !== Graphs.WEATHERMAPS) {
        chartInstance.current.setOption({
          yAxis: getYAxisOptions(!allDeselected)
        });
      }
    }
  };
    const scrollRef = useRef(null);
    const handleScroll = (scrollOffset) => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft += scrollOffset;
      }
    };
    const showArrows = legend?.length > 5

    return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div style={{ marginLeft:'50px',display: 'flex', justifyContent: 'center',    alignitems: 'center'}}>
        {showArrows && <span style={{  display:'flex',justifyContent:'center',alignItems:'center',paddingTop:'1px'}} className={`${style.leftarrow} ${style.arrow}`} onClick={() => handleScroll(-200)}>
       <img src={IMAGES.arrows}  style={{  height:'20px',cursor:'pointer' }} alt="Left" />
     </span>}
      <div ref={scrollRef} className={styles.hideScrollbar} style={{display: 'flex', overflowX: 'auto', whiteSpace: 'nowrap', margin: '10px 0',padding: '4px 8px',}}>
            {legend?.map((item, index) => (
              <label key={item} 
              onMouseEnter={() => {
                if (chartInstance.current) {
                  const option = chartInstance.current.getOption();
                  const seriesIndex = option.series.findIndex(s => s.name === item);
                  if (seriesIndex !== -1) {
                    option.series[seriesIndex].z = 1000; 
                    chartInstance.current.setOption({ series: option.series });
                  }
                }
              }}
              onMouseLeave={() => {
                if (chartInstance.current) {
                  const option = chartInstance.current.getOption();
                  const seriesIndex = option.series.findIndex(s => s.name === item);
                  if (seriesIndex !== -1) {
                    option.series[seriesIndex].z = 1;
                    chartInstance.current.setOption({ series: option.series });
                  }
                }
              }}
              style={{ marginRight: '16px', position:"relative",display:'flex',alignItems:'center', cursor:'pointer',fontFamily: 'VodafoneRg-Regular',fontSize: '16px',color: defaultColors[index % defaultColors.length] }}>
              <input
                type="checkbox"
                checked={selectedKeys[item]}
                onChange={() => toggleSeries(item)}
                className={styles.customcheckbox}
                onMouseEnter={() => {
                  if (chartInstance.current) {
                   const option = chartInstance.current.getOption();
                   const seriesIndex = option.series.findIndex(s => s.name === item);
                  if (seriesIndex !== -1) {
                    option.series[seriesIndex].z = 1000; 
                    chartInstance.current.setOption({ series: option.series });
                    }
                   }
                 }}
               onMouseLeave={() => {
                if (chartInstance.current) {
                 const option = chartInstance.current.getOption();
                 const seriesIndex = option.series.findIndex(s => s.name === item);
                 if (seriesIndex !== -1) {
                 option.series[seriesIndex].z = 1; 
                 chartInstance.current.setOption({ series: option.series });
                }
               }
              }}
            style={{ backgroundColor: selectedKeys[item]? defaultColors[index % defaultColors.length] :"#ffffff"}}/>
                <span  className={styles.tick} > ✓</span>
                {item}
              </label>
            ))}
          </div>
         {showArrows && <span style={{  display:'flex',justifyContent:'center',alignItems:'center',paddingTop:'1px'}} className={`${style.rightarrow} ${style.arrowparent}`} onClick={() => handleScroll(200)}>
      <img src={IMAGES.arrows}  style={{  height:'20px',cursor:'pointer' ,   transform: 'rotate(180deg)'}} alt="Right" />
     </span>}
          </div>
        <div ref={chartRef} className={`${style}`}></div>
      </div>
    );
  };
  
  export default LineChart;